module.exports = __webpack_public_path__ + "img/dashboard.d1665413.svg";